import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, computed, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

export interface AddArtikelOption {
  nummer: string;
  name: string;
  beschreibung: string;
  preis: number;
  vorschlag: number;
  empfehlung: number;
  einheit: string;
  pkg: boolean;
  min: number | null;
  max: number | null;
}

@Component({
  selector: 'app-add-artikel-dialog',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './add-artikel-dialog.component.html',
  styleUrl: './add-artikel-dialog.component.scss',
})
export class AddArtikelDialogComponent {
  @Output() closed = new EventEmitter<void>();
  @Output() artikelSelected = new EventEmitter<AddArtikelOption>();

  private readonly availableArtikelSignal = signal<AddArtikelOption[]>([]);
  private readonly existingArtikelNumbersSignal = signal<string[]>([]);

  protected readonly searchTerm = signal('');

  @Input() set availableArtikel(value: AddArtikelOption[]) {
    this.availableArtikelSignal.set(value);
  }

  @Input() set existingArtikelNumbers(value: string[]) {
    this.existingArtikelNumbersSignal.set(value);
  }

  protected readonly filteredArtikel = computed(() => {
    const term = this.searchTerm().trim().toLowerCase();
    const existingNumbers = new Set(this.existingArtikelNumbersSignal());

    return this.availableArtikelSignal()
      .filter((item) => !existingNumbers.has(item.nummer))
      .filter((item) => {
        if (!term) {
          return true;
        }

        return (
          item.name.toLowerCase().includes(term) ||
          item.beschreibung.toLowerCase().includes(term) ||
          item.nummer.toLowerCase().includes(term)
        );
      });
  });

  protected updateSearchTerm(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchTerm.set(input.value);
  }

  protected closeDialog(): void {
    this.closed.emit();
  }

  protected addArtikel(artikel: AddArtikelOption): void {
    this.artikelSelected.emit(artikel);
  }
}